import { useState, useEffect } from 'react';
import DepartmentSkillsSelector from '../components/Staffrecord/Editform/DepartmentSkillsSelector';
import './JobRequirementForm.css';
import { useToast } from '../components/Admissionform/ToastManager';
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import DatePicker from "react-multi-date-picker";

const PlacementOfficer = () => {
    const [formData, setFormData] = useState({
        jobReqStatus: 'Open',
        createdDate: '',
        createdBy: '',
        jobTitle: '',
        jobDescription: '',
        companyName: '',
        jobLocation: '',
        qualification: '',
        passedOutYear: '',
        experienceRequired: '',
        salary: '',
        bond: '',
        bondDetails: '',
        interviewType: '',
        directApplyLink: '',
        modeOfInterview: '',
        numberOfOpenings: '',
        numberOfRounds: '',
        interviewDate: '',
        interviewTime: '',
        interviewLocation: '',
        venue: '',
        additionalDetails: '',
        additionalSkills: '',
        companyHRName: '',
        companyHRContact: '',
        companyHREmail: '',
        gender: 'All'
    });
    const [department, setDepartment] = useState('');
    const [skillsKnown, setSkillsKnown] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { showSuccess, showError, showWarning } = useToast();
    const navigate = useNavigate();
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [allBranches, setAllBranches] = useState([]);

    // Add useEffect to fetch branches
    useEffect(() => {
        const fetchBranches = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/location`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    const activeBranches = data.filter(loc => loc.status === true);
                    setAllBranches(activeBranches);
                    // Set "All Branches" as default
                    setSelectedBranches(activeBranches.map(b => b.branch));
                }
            } catch (error) {
                console.error('Error fetching branches:', error);
                showError('Failed to load branches');
            }
        };

        fetchBranches();
    }, []);


    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        const loggedInUser = localStorage.getItem("emp_name") || "";

        setFormData(prev => ({
            ...prev,
            createdDate: today,
            createdBy: loggedInUser
        }));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        const requiredFields = [
            'createdBy', 'jobTitle', 'jobDescription', 'companyName',
            'jobLocation', 'qualification',
            'passedOutYear', 'experienceRequired', 'salary', 'bond',
            'interviewType', 'modeOfInterview', 'numberOfOpenings', 'numberOfRounds',
            'companyHRName', 'companyHRContact', 'companyHREmail'
        ];

        const missingFields = requiredFields.filter(field => !formData[field]);

        if (!department) missingFields.push('department');
        if (skillsKnown.length === 0) missingFields.push('skillSet');
        if (selectedBranches.length === 0) missingFields.push('allowedBranches');

        if (formData.bond === 'Yes' && !formData.bondDetails) {
            missingFields.push('bondDetails');
        }
        if (formData.interviewType === 'Direct Apply' && !formData.directApplyLink) {
            missingFields.push('directApplyLink');
        }
        if (formData.interviewType === 'Pumo Campus Drive') {
            if (!formData.interviewDate) missingFields.push('interviewDate');
            if (!formData.interviewTime) missingFields.push('interviewTime');
            if (!formData.venue) missingFields.push('venue');
        }

        if (missingFields.length > 0) {
            showWarning(`Please fill all required fields: ${missingFields.join(', ')}`);
            return;
        }

        setIsSubmitting(true);

        try {
            const token = localStorage.getItem('token'); // ✅ GET TOKEN

            if (!token) {
                showError("Session expired. Please login again.");
                return;
            }

            const apiData = {
                ...formData,
                department,
                skillSet: skillsKnown.join(", "),
                additionalSkills: formData.additionalSkills || null,
                allowedBranches: selectedBranches.length === allBranches.length
                    ? "All Branches"
                    : selectedBranches.join(", "),
                directApplyLink: formData.directApplyLink || null,
                bondDetails: formData.bondDetails || null,
                interviewDate: formData.interviewDate || null,
                interviewTime: formData.interviewTime || null,
                interviewLocation: formData.interviewLocation || null,
                venue: formData.venue || null,
                additionalDetails: formData.additionalDetails || null,
                companyHRName: formData.companyHRName || null,
                companyHRContact: formData.companyHRContact || null,
                companyHREmail: formData.companyHREmail || null,
                gender: formData.gender || null,
            };

            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/placement-details`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}` // ✅ TOKEN ADDED
                    },
                    body: JSON.stringify(apiData)
                }
            );

            const result = await response.json();

            if (response.ok) {
                const newJobId = result.jobReqId;   // <-- ID from backend

                showSuccess(`Job Requirement Created Successfully! Job ID: ${newJobId}`);

                // go to edit page
                navigate(`/edit-job/${newJobId}`);
            }
            else {
                showError(result.message || 'Failed to create job requirement');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            showError('Failed to submit form. Please check your connection and try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        navigate('/placementdb');
    };

    // const experienceLevels = ['Fresher', '<1year', '1-2years', '2-3years', '>3years'];
    const interviewTypes = ['Walk-in', 'Pumo Campus Drive', 'Direct Apply', 'Pumo Scheduled Interview'];
    const interviewModes = ['In-Person', 'Virtual'];
    const rounds = ['1', '2', '3'];

    return (
        <div className="container">
            <div className="pagesf-wrapper">
                <div className="form">
                    <div style={{ padding: '32px' }}>

                        {/* <div className="form-row">
                           
                            <div className="form-group">
                                <label>Job Requirement Status <span className="mandatory">*</span></label>
                                <select
                                    name="jobReqStatus"
                                    value={formData.jobReqStatus}
                                    onChange={handleChange}
                                >
                                    <option value="Open">Open</option>
                                    <option value="Closed">Closed</option>
                                    <option value="On Hold">On Hold</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Created Date <span className="mandatory">*</span></label>
                                <input
                                    type="date"
                                    name="createdDate"
                                    value={formData.createdDate}
                                    readOnly
                                    style={{ backgroundColor: '#f5f7fa', cursor: 'not-allowed' }}
                                />
                            </div>
                            <div className="form-group">
                                <label>Created By <span className="mandatory">*</span></label>
                                <input
                                    type="text"
                                    name="createdBy"
                                    value={formData.createdBy}
                                    onChange={handleChange}
                                    placeholder="Enter creator name"
                                />
                            </div>
                        </div> */}
                        {/* Allowed Branches */}
                        <div className="form-group">
                            <label>Allowed Branches <span className="mandatory">*</span></label>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>

                                {/* Select All */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <input
                                        type="checkbox"
                                        className='cb'
                                        checked={selectedBranches.length === allBranches.length && allBranches.length > 0}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setSelectedBranches(allBranches.map(b => b.branch));
                                            } else {
                                                setSelectedBranches([]);
                                            }
                                        }}
                                    />
                                    <span>All Branches</span>
                                </div>

                                {/* react-select multi dropdown */}
                                <Select
                                    isMulti
                                    options={allBranches.map(b => ({
                                        value: b.branch,
                                        label: b.branch
                                    }))}
                                    value={allBranches
                                        .map(b => ({ value: b.branch, label: b.branch }))
                                        .filter(opt => selectedBranches.includes(opt.value))
                                    }
                                    onChange={(selected) =>
                                        setSelectedBranches(selected ? selected.map(v => v.value) : [])
                                    }
                                    placeholder="Select allowed branches..."
                                />

                                {/* info */}
                                {selectedBranches.length > 0 && selectedBranches.length < allBranches.length && (
                                    <div
                                        style={{
                                            fontSize: '13px',
                                            color: '#2563eb',
                                            padding: '8px',
                                            backgroundColor: '#eff6ff',
                                            borderRadius: '4px'
                                        }}
                                    >
                                        Selected: {selectedBranches.join(', ')}
                                    </div>
                                )}
                            </div>
                        </div>


                        <div className="form-row">
                            <div className="form-group">
                                <label>Job Title <span className="mandatory">*</span></label>
                                <input
                                    type="text"
                                    name="jobTitle"
                                    value={formData.jobTitle}
                                    onChange={handleChange}
                                    placeholder="Enter job title"
                                />
                            </div>
                            <div className="form-group">
                                <label>Company Name <span className="mandatory">*</span></label>
                                <input
                                    type="text"
                                    name="companyName"
                                    value={formData.companyName}
                                    onChange={handleChange}
                                    placeholder="Enter company name"
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Job Description <span className="mandatory">*</span></label>
                            <textarea
                                name="jobDescription"
                                value={formData.jobDescription}
                                onChange={handleChange}
                                placeholder="Enter detailed job description"
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Job Location <span className="mandatory">*</span></label>
                                <input
                                    type="text"
                                    name="jobLocation"
                                    value={formData.jobLocation}
                                    onChange={handleChange}
                                    placeholder="Enter job location"
                                />
                            </div>
                            <div className="form-group">
                                <label>Qualification <span className="mandatory">*</span></label>
                                <input
                                    type="text"
                                    name="qualification"
                                    value={formData.qualification}
                                    onChange={handleChange}
                                    placeholder="e.g., B.Tech, M.Tech, MCA"
                                />
                            </div>
                        </div>

                        <DepartmentSkillsSelector
                            department={department}
                            skillsKnown={skillsKnown}
                            onDepartmentChange={setDepartment}
                            onSkillsChange={setSkillsKnown}
                            departmentLabel="Department"
                            skillsLabel="Skill Set Required"
                            departmentRequired={true}
                            skillsRequired={true}
                            layout="horizontal"
                        />
                        <div className="form-row">
                            <div className="form-group">
                                <label>Additional Skills (Optional)</label>
                                <input
                                    name="additionalSkills"
                                    value={formData.additionalSkills}
                                    onChange={handleChange}
                                    placeholder="List out any additional skills not listed in the 'Skills Set Required' Dropdown "
                                />
                            </div>
                            <div className="form-group">
                                <label>Gender</label>
                                <select
                                    name="gender"
                                    value={formData.gender}
                                    onChange={handleChange}
                                >
                                    <option value="All">All</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Passed Out Year <span className="mandatory">*</span></label>
                                <input
                                    type="text"
                                    name="passedOutYear"
                                    value={formData.passedOutYear}
                                    onChange={handleChange}
                                    placeholder="e.g., 2024, 2023-2024"
                                />
                            </div>
                            <div className="form-group">
                                <label>
                                    Experience Required <span className="mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="experienceRequired"
                                    value={formData.experienceRequired}
                                    onChange={handleChange}
                                    placeholder="e.g. Fresher / 6 months / 1-3 years"
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Salary (in LPA) <span className="mandatory">*</span></label>
                                <input
                                    type="text"
                                    name="salary"
                                    value={formData.salary}
                                    onChange={handleChange}
                                    placeholder="Enter salary (e.g. 3 LPA, 25,000 – 30,000, As per company)"
                                />
                            </div>
                            <div className="form-group">
                                <label>Bond <span className="mandatory">*</span></label>
                                <select
                                    name="bond"
                                    value={formData.bond}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Option</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>

                        {formData.bond === 'Yes' && (
                            <div className="form-group">
                                <label>Bond Details <span className="mandatory">*</span></label>
                                <textarea
                                    name="bondDetails"
                                    value={formData.bondDetails}
                                    onChange={handleChange}
                                    placeholder="Enter bond details (duration, amount, terms, etc.)"
                                />
                            </div>
                        )}

                        <div className="form-row">
                            <div className="form-group">
                                <label>Number of Job Openings <span className="mandatory">*</span></label>
                                <input
                                    type="number"
                                    name="numberOfOpenings"
                                    value={formData.numberOfOpenings}
                                    onChange={handleChange}
                                    placeholder="Enter number of openings"
                                />
                            </div>
                            <div className="form-group">
                                <label>Number of Interview Rounds <span className="mandatory">*</span></label>
                                <select
                                    name="numberOfRounds"
                                    value={formData.numberOfRounds}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Rounds</option>
                                    {rounds.map(round => (
                                        <option key={round} value={round}>{round}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Interview Type <span className="mandatory">*</span></label>
                                <select
                                    name="interviewType"
                                    value={formData.interviewType}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Interview Type</option>
                                    {interviewTypes.map(type => (
                                        <option key={type} value={type}>{type}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Mode of Interview <span className="mandatory">*</span></label>
                                <select
                                    name="modeOfInterview"
                                    value={formData.modeOfInterview}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Mode</option>
                                    {interviewModes.map(mode => (
                                        <option key={mode} value={mode}>{mode}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {formData.interviewType === 'Direct Apply' && (
                            <div className="form-group">
                                <label>Direct Apply Link <span className="mandatory">*</span></label>
                                <input
                                    type="url"
                                    name="directApplyLink"
                                    value={formData.directApplyLink}
                                    onChange={handleChange}
                                    placeholder="Enter application link"
                                />
                            </div>
                        )}

                        {(formData.interviewType === 'Walk-in' ||
                            formData.interviewType === 'Pumo Scheduled Interview') && (
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Interview Dates</label>

                                        <DatePicker
                                            multiple
                                            closeOnSelect={false}
                                            format="DD-MM-YYYY"   // 👈 changed format
                                            value={formData.interviewDate ? formData.interviewDate.split(",") : []}
                                            onChange={(dates) => {
                                                const formatted = dates.map(d => d.format("DD-MM-YYYY")); // 👈 changed here
                                                setFormData(prev => ({
                                                    ...prev,
                                                    interviewDate: formatted.join(",")
                                                }));
                                            }}
                                            placeholder="Select interview dates"
                                            style={{
                                                width: "100%",
                                                height: "38px",
                                                borderRadius: "6px",
                                                border: "1px solid #d1d5db",
                                                padding: "0 10px"
                                            }}
                                        />

                                    </div>

                                    <div className="form-group">
                                        <label>Interview Location</label>
                                        <input
                                            type="text"
                                            name="interviewLocation"
                                            value={formData.interviewLocation}
                                            onChange={handleChange}
                                            placeholder="Enter interview location"
                                        />
                                    </div>
                                </div>
                            )}

                        {formData.interviewType === 'Pumo Campus Drive' && (
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Date <span className="mandatory">*</span></label>
                                    <input
                                        type="date"
                                        name="interviewDate"
                                        value={formData.interviewDate}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Time <span className="mandatory">*</span></label>
                                    <input
                                        type="time"
                                        name="interviewTime"
                                        value={formData.interviewTime}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Venue <span className="mandatory">*</span></label>
                                    <input
                                        type="text"
                                        name="venue"
                                        value={formData.venue}
                                        onChange={handleChange}
                                        placeholder="Enter venue"
                                    />
                                </div>
                            </div>
                        )}

                        <div className="form-group">
                            <label>Additional Details</label>
                            <textarea
                                name="additionalDetails"
                                value={formData.additionalDetails}
                                onChange={handleChange}
                                placeholder="Any additional information"
                            />
                        </div>
                        {/* Confidential Note */}
                      <div className="confidential-note">
                            <strong>Confidential Information:</strong> The below HR contact details are restricted and can only be viewed by the requirement creator and Super Admin users.
                        </div>

                        <div className="form-group">
                            <label>Company HR Name <span className="mandatory">*</span></label>
                            <input
                                type="text"
                                name="companyHRName"
                                value={formData.companyHRName}
                                onChange={handleChange}
                                placeholder="Enter HR name"
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Company HR Contact Number <span className="mandatory">*</span></label>
                                <input
                                    type="tel"
                                    name="companyHRContact"
                                    value={formData.companyHRContact}
                                    onChange={handleChange}
                                    placeholder="Enter contact number"
                                />
                            </div>
                            <div className="form-group">
                                <label>Company HR Email ID <span className="mandatory">*</span></label>
                                <input
                                    type="email"
                                    name="companyHREmail"
                                    value={formData.companyHREmail}
                                    onChange={handleChange}
                                    placeholder="Enter email address"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-actions">
                        <button
                            type="button"
                            className="cancel-btn"
                            onClick={handleCancel}
                            disabled={isSubmitting}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="submit-btn"
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlacementOfficer;